import { render, staticRenderFns } from "./PartnerRegister.vue?vue&type=template&id=6f18e155"
import script from "./PartnerRegister.vue?vue&type=script&lang=ts"
export * from "./PartnerRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports